<div class="selected-language-wrapper"
	 cpClickableElement [elementDescription]="(isAuthenticated ? 'UserMenu' : 'LanguageSelectionMenu') | cpActionTranslate: [selectedLanguage?.patientDescription || selectedLanguage?.language] | async"
	 aria-haspopup="true" [attr.aria-expanded]="showTheTooltip"
	 cpClickOut (clickOut)="setInitialState()"
	 (click)="showTheTooltip = !showTheTooltip; languageOptionsClosed = true; accessibilityOptionsClosed = true;">
	<ng-container *ngIf="isAuthenticated; else languageStrip">
		<i class="pp-icon-info"></i>
		<div class="text">{{authProviderService.currentPatient.displayName}}</div>
	</ng-container>
	<i #theAnchor class="collapsible" [ngClass]="[showTheTooltip ? 'pp-icon-expand' : 'pp-icon-collapse']"></i>
</div>

<ng-template #languageStrip>
	<i class="pp-icon-language_selection"></i>
	<div class="text">{{selectedLanguage?.patientDescription || selectedLanguage?.language}}</div>
</ng-template>

<app-tooltip *ngIf="showTheTooltip"
			 class="bgc-white"
			 [ngClass]="{'bgc-grey': isAuthenticated && languageOptionsClosed}"
			 [anchor]="theAnchor"
			 [width]="'200px'"
			 [direction]="'top'"
			 [contentPadding]="0"
			 [forceOpen]="true">
	<ul class="menu-container" [attr.role]="isAuthenticated ? 'menu' : 'none'">
		<li class="selected-language-selection-items-wrapper" role="none">
			<div class="selected-language-tooltip-content-area no-seperator" [class.expanded]="!languageOptionsClosed"
				 cpClickableElement [elementDescription]="'LanguageSelectionMenu' | cpActionTranslate: [selectedLanguage?.patientDescription || selectedLanguage?.language] | async"
				 aria-haspopup="true" [attr.aria-expanded]="!languageOptionsClosed"
				 *ngIf="isAuthenticated" (click)="languageOptionsClosed = !languageOptionsClosed; $event.stopPropagation()">
				<ng-container *ngTemplateOutlet="languageStrip"></ng-container>
				<i class="collapsible" [ngClass]="[!languageOptionsClosed ? 'pp-icon-expand' : 'pp-icon-collapse']"></i>
			</div>

			<ul role="menu" *ngIf="!isAuthenticated || !languageOptionsClosed">
				<app-language-selection-item *ngFor="let language of languages"
											 [language]="language"
											 [selected]="language === selectedLanguage"
											 [indented]="isAuthenticated"
											 (languageSelected)="languageSelectedHandler($event)"
											 role="none">
				</app-language-selection-item>
			</ul>
		</li>

		<ng-container *ngIf="isAuthenticated">
			<li class="selected-language-tooltip-content-area"
				 cpClickableElement elementRole="menuitem" [elementDescription]="'ContactUs' | cpActionTranslate | async"
				 (click)="showContactUsPage()">
				<i class="pp-icon-info"></i>
				<div class="text">{{'ContactUs' | cpActionTranslate | async}}</div>
			</li>

			<li class="selected-language-tooltip-content-area"
				 cpClickableElement elementRole="menuitem" [elementDescription]="'ChangePassword' | cpActionTranslate | async"
				 *ngIf="isInternalAuthentication" (click)="changePassword()">
				<i class="pp-icon-info"></i>
				<div class="text">{{'ChangePassword' | cpActionTranslate | async}}</div>
			</li>

			<li role="none">
				<div class="selected-language-tooltip-content-area" [class.expanded]="!accessibilityOptionsClosed"
					 cpClickableElement [elementDescription]="'Accessibility' | cpActionTranslate | async"
					 aria-haspopup="true" [attr.aria-expanded]="!accessibilityOptionsClosed"
					 (click)="accessibilityOptionsClosed = !accessibilityOptionsClosed; $event.stopPropagation()">
					<i class="pp-icon-accessibility"></i>
					<div class="text">{{'Accessibility' | cpActionTranslate | async}}</div>
					<i class="collapsible" [ngClass]="[accessibilityOptionsClosed ? 'pp-icon-collapse' : 'pp-icon-expand']"></i>
				</div>

				<ul class="selected-language-selection-items-wrapper expanded" *ngIf="!accessibilityOptionsClosed" role="menu">
					<li class="accessibility-menu-item" cpClickableElement elementRole="menuitem" (click)="showAccessibilityStatementPage()">
						<i class="pp-icon-patient_forms"></i>
						{{'AccessibilityStatement' | cpActionTranslate | async}}
					</li>

					<li class="accessibility-menu-item" cpClickableElement elementRole="menuitem" (click)="toggleTheme()"
						*ngIf="themeService.isFactoryThemeAvailable && themeService.isCustomThemeAvailable">
						<i class="pp-icon-brush"></i>
						{{(currentTheme === 'factory' ? 'SetCustomTheme' : 'SetFactoryTheme') | cpActionTranslate | async}}
					</li>
				</ul>
			</li>

			<li class="selected-language-tooltip-content-area"
				 cpClickableElement elementRole="menuitem" [elementDescription]="'About' | cpActionTranslate | async"
				 (click)="showAboutPage()">
				<i class="pp-icon-info"></i>
				<div class="text">{{'About' | cpActionTranslate | async}}</div>
			</li>

			<li class="selected-language-tooltip-content-area"
				 cpClickableElement elementRole="menuitem" [elementDescription]="'Logout' | cpActionTranslate | async"
				 (click)="logoutClickHandler()">
				<i class="pp-icon-close"></i>
				<div class="text">{{'Logout' | cpActionTranslate | async}}</div>
			</li>
		</ng-container>
	</ul>
</app-tooltip>

<ng-template #contactUsTitle>
	<div class="popup-title-container language-selection">
		<h1 class="popup-title-text" id="contact-us-title">{{'ContactUs' | cpTitleTranslate | async}}</h1>
		<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
	</div>
</ng-template>

<ng-template #aboutTitle>
	<div class="popup-title-container language-selection">
		<h1 class="popup-title-text" id="about-title">{{'About' | cpTitleTranslate | async}}</h1>
		<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
	</div>
</ng-template>

<ng-template #accessibilityStatementTitle>
	<div class="popup-title-container language-selection">
		<h1 class="popup-title-text" id="accessibility-statementTitle">{{'AccessibilityStatement' | cpTitleTranslate | async}}</h1>
		<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
	</div>
</ng-template>

<ng-template #changePasswordTitle>
	<div class="popup-title-container language-selection">
		<h1 class="popup-title-text" id="change-password-title">{{'ChangePassword' | cpLoginTranslate | async}}</h1>
		<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
	</div>
</ng-template>
